// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import RichTextBlock from '@uswitch/ev-components/lib/components/modules/rich-text-block'
import {
  moneyHeadingStyles,
  uswitchHeadingStyles,
  richTextBlockStyleByBrand,
} from '../single-column-rich-text/styles'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'

const TwoColumnRichText = (props) => {
  const { content: document, contentTwo: documentTwo, heading = undefined, brand, name } = props

  return (
    <div className='TwoColumnRichTextNew' id={removeWhitespaceAndSpecialChars(name)}>
      {heading && (
        <RichTextBlock
          {...props}
          content={heading}
          style={brand === 'money' ? moneyHeadingStyles : uswitchHeadingStyles}
        />
      )}
      <div className='TwoColumnRichTextNew__container'>
        <div className='TwoColumnRichTextNew__container__columnOne'>
          <RichTextBlock {...props} content={document} style={richTextBlockStyleByBrand(brand)} />
        </div>
        <div className='TwoColumnRichTextNew__container__columnTwo'>
          <RichTextBlock
            {...props}
            content={documentTwo}
            style={richTextBlockStyleByBrand(brand)}
          />
        </div>
      </div>
    </div>
  )
}

export default TwoColumnRichText
